var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"burger",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$emit('onToggle')}}},[_c('span',{staticClass:"burger__text"},[_vm._v(_vm._s(_vm.$t("message.menu")))]),_vm._v(" "),_c('span',{staticClass:"burger__toggle"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-353f71b2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Burger.vue
// module id = 43
// module chunks = 0